<template>
  <span>

    <SemiologiaPediatrica 
      v-if="esPediatria"
      :onlyView="onlyView"
    />

    <SemiologiaPsicologica
      v-if="esPsicologia"
      :onlyView="onlyView"
      :dataSaved="dataSaved"
    />


    <SemiologiaNutricional 
      v-if="esNutricion"
      :dataSaved="dataSaved"
      :lastData="lastData"
      :onlyView="onlyView"
    />

    <SemiologiaCardiologica
      v-if="esCardiologia"
    />

    <SemiologiaOdontologica
    v-if="esOdontologia"
     :dataSaved="dataSaved"
      :onlyView="onlyView"
      :esCrear="esCrear"
      :isAuditoria="isAuditoria"
    />

    <!-- <EvaluacionOdontologica/> -->
  </span>
</template>

<script>
import { mapState } from 'vuex';
import SemiologiaPsicologica  from '@/views/atencionCita/components/Anamnesis/Semiologias/SemiologiaPsicologica/SemiologiaPsicologica.vue';
import SemiologiaPediatrica   from '@/views/atencionCita/components/Anamnesis/Semiologias/SemiologiaPediatrica/SemiologiaPediatrica.vue';
import SemiologiaNutricional  from '@/views/atencionCita/components/Anamnesis/Semiologias/SemiologiaNutricional/SemiologiaNutricional.vue';
import SemiologiaCardiologica from '@/views/atencionCita/components/Anamnesis/Semiologias/SemiologiaCardiologica/SemiologiaCardiologica.vue';
import EvaluacionOdontologica from '@/views/atencionCita/components/Anamnesis/Semiologias/EvaluacionOdontologica/EvaluacionOdontologica.vue';

import { ESPECIALIDAD }       from '@/shared/constants';
import { semiologiasService } from '@/views/atencionCita/services/';
import { atencionMedicaService } from '../../../../atencionMedica/services';
import SemiologiaOdontologica from './SemiologiaOdontologica/SemiologiaOdontologica.vue';

export default {

  name: "SemiologiasMain",
  
  components: {
    SemiologiaPsicologica,
    SemiologiaPediatrica,
    SemiologiaNutricional,
    SemiologiaCardiologica,
    EvaluacionOdontologica,
    SemiologiaOdontologica
  },


  props: {
    onlyView: {
      type: Boolean,
      default: false
    },

    isAuditoria: {
      type: Boolean,
      default: false
    },


    tokenAtencion: {
      type: String,
      default: null
    },

    esCrear:{
      default: false,
      required:false
    }
  },


  data() {
    return {
      dataSaved: null,
      dataTipo: null,
      lastData: null
    }
  },


  async created() {
    await this.loadData();
    this.loadLastDataSemiologia();
    localStorage.removeItem('odontograma');

  },


  methods: {

    async loadData(){
      let tokenAtencionActual = this.tokenAtencion;

     
      if(!tokenAtencionActual) tokenAtencionActual = this.$route.params.token;
      if(!tokenAtencionActual) return;
      
      const dataSemiologia = await semiologiasService.getData(tokenAtencionActual);
      if(!dataSemiologia?.semiologia) return;

      const dataParsed = dataSemiologia.semiologia ? JSON.parse(dataSemiologia.semiologia) : null;
      if(!dataParsed) return;

      this.dataTipo = dataParsed?.tipo

      if(this.onlyView)
        this.$store.commit('setSemiologiaView', dataParsed.data)
      

      if(dataParsed?.tipo === 'pediatria'){

        if(!this.onlyView){
          this.$store.commit('setSemPediatrica', dataParsed.data)
        }
      }
       

      if(dataParsed?.tipo === 'psicologia' || dataParsed?.tipo === 'nutricional' || dataParsed?.tipo === 'odontologica'){
        this.dataSaved = dataParsed.data
        
      }

      
    },


    async loadLastDataSemiologia(){
      const tokenAtencion = this.$route.params.token;
      if(this.onlyView) return;
      if(tokenAtencion) return;
      console.log("ENTRA ACA 1")
      const pacienteId = this.stDataPaciente?.id;
      if (!pacienteId) return
      console.log("ENTRA ACA 2")
      const allAtenciones = await atencionMedicaService.getAllAtencionesByPaciente(pacienteId);
      if (!allAtenciones?.atenciones?.length) return;

      const dataAtenciones = allAtenciones.atenciones;
      const atencionesConSemiologia = dataAtenciones.filter( atencion =>  atencion.semiologia);
      console.log("ENTRA ACA 3")
      const atencionesMapped = atencionesConSemiologia.map( a => ({
        idAtencion    : a.id,
        tokenAtencion : a.token,
        fecha         : a.cita.fechaCita,
        semiologia    : JSON.parse(a.semiologia)
      }))

      const lastSemiologia = atencionesMapped.find( a => a.semiologia?.tipo === this.especialidadDoctor);
      const lastSemiologiaOdontologica = atencionesMapped.find( a => a.semiologia?.tipo === 'odontologica');
      
      if (this.esCrear && lastSemiologiaOdontologica) { this.dataSaved = lastSemiologiaOdontologica.semiologia.data}
       
     
      console.log("ENTRA ACA 4")
      if(lastSemiologia?.semiologia?.tipo !== 'pediatria' || lastSemiologia?.semiologia?.tipo !== 'nutricional' || lastSemiologia?.semiologia?.tipo !== 'odontologica') {
      
      this.mountedLastData(lastSemiologia?.semiologia?.data, lastSemiologia?.semiologia?.tipo);
      this.$store.commit('setLastSemiologia', lastSemiologia);
      console.log("ENTRA ACA 5")
      }
    },



    mountedLastData(data, tipo){

      if(this.onlyView){
        this.$store.commit('setSemiologiaView', data)
        return;
      }

      if(tipo === 'pediatria'){
        this.$store.commit('setSemPediatrica', data)
      }

      if(tipo === 'psicologia' || tipo === 'nutricional'){
        this.lastData = data
      }
    },
    
  },


  computed: {
    ...mapState({
      codEsp          : state => state.atencionCita.dataCita?.doctor.especialidad.codEsp,
      stEspecialidad  : state => state.atencionCita.dataCita?.doctor.especialidad,
      stSemFisiatrica : state => state.atencionCita.semiologias?.semFisiatrica,
      stMotivoConsulta: state => state.atencionCita.anamnesis?.motivoConsulta?.tipoVez,
      stDataDoctor    : state => state.atencionCita.dataCita?.doctor,
      stDataPaciente  : state => state.atencionCita.dataCita?.paciente,

      stLastSemiologia: state => state.atencionCita.semiologias?.lastSemiologia
    }),


    esPediatria() {
      if(this.onlyView)
        return this.dataTipo === 'pediatria';
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.PEDIATRA;
    },

    esPsicologia() {
      if(this.onlyView)
        return this.dataTipo === 'psicologia';
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.PSICOLOGIA;
    },

    esNutricion(){
      if(this.onlyView)
        return this.dataTipo === 'nutricional';
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.NUTRICION;
    },

    esCardiologia(){
      if(this.onlyView)
        return this.dataTipo === 'cardiologia';
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.CARDIOLOGIA;
    },

    esOdontologia(){
      if(this.onlyView)
        return this.dataTipo === 'odontologia';
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.ODONTOLOGIA;
    },


    especialidadDoctor(){
      if (this.stDataDoctor?.especialidad.codEsp === ESPECIALIDAD.PEDIATRA)
        return 'pediatria';
      if (this.stDataDoctor?.especialidad.codEsp === ESPECIALIDAD.PSICOLOGIA)
        return 'psicologia';
      if (this.stDataDoctor?.especialidad.codEsp === ESPECIALIDAD.NUTRICION)
        return 'nutricional';

      return null;
    }
  },
  
  watch:{
    stDataPaciente(){
      this.loadLastDataSemiologia();
    },
    isAuditoria: {
      deep:true,
      immediate:true,
      handler(nv){
        console.log("es auditoria main", nv)
      }
    }
  }
  
}
</script>


<style>

.dark-layout .vs--disabled .vs__selected{
  color: rgb(255, 255, 255)!important;
}

.dark-layout .vs--disabled.vs--single .vs__selected{
  color: rgb(255, 255, 255)!important;
}

.vs--disabled .vs__selected{
  color: rgb(136, 136, 136)!important;
}
</style>